// 从state中派生的计算属性，方便组件获取状态
const getters = {
  // 用户模块
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  isLogin: state => !!state.user.token, // 是否登录（token存在即为登录）
  roles: state => state.user.roles || [] // 用户角色
}

export default getters